// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaPlayerProgress__progress-c22a36 {
  --progress-background: var(--addition-50_40);
  --progress-pin-size: 16px;
  position: relative;
  height: 6px;
  cursor: pointer;
}

.MediaPlayerProgress__progress-c22a36:focus-visible {
  box-shadow: 0 0 0 2px var(--info-30);
}

.MediaPlayerProgress__progress-bar-wrapper-ef39e2 {
  position: relative;
  height: 100%;
  border-radius: 8px;
  overflow: visible;
}

.MediaPlayerProgress__progress-background-df572c {
  width: 100%;
  height: 100%;
  background-color: var(--progress-background);
}

.MediaPlayerProgress__progress-bar-d31794 {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  max-width: 100%;
  background-color: var(--brand-primary-40);
}

.MediaPlayerProgress__progress-bar-animated-bb62c0 {
  transition: width 300ms linear;
  will-change: width;
}

.MediaPlayerProgress__progress-buffer-ad2712 {
  position: absolute;
  top: 0;
  height: 100%;
  max-width: 100%;
  background-color: var(--progress-background);
}

.MediaPlayerProgress__progress-pin-a76df6 {
  position: absolute;
  top: 50%;
  inset-inline-end: 0px;
  visibility: hidden;
  height: var(--progress-pin-size);
  width: var(--progress-pin-size);
  background-color: var(--brand-primary-40);
  border-radius: 50%;
  transform: translate(50%, -50%);
}

.MediaPlayerProgress__progress-c22a36:hover .MediaPlayerProgress__progress-pin-a76df6,
.MediaPlayerProgress__progress-pin-active-fab301 {
  visibility: visible;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Media/components/MediaPlayerProgress/MediaPlayerProgress.styles.m.css"],"names":[],"mappings":"AAAA;EACE,4CAAA;EACA,yBAAA;EAEA,kBAAA;EACA,WAAA;EACA,eAAA;AAAF;;AAGA;EACE,oCAAA;AAAF;;AAGA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,4CAAA;AAAF;;AAGA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;EACA,yCAAA;AAAF;;AAGA;EACE,8BAAA;EACA,kBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,MAAA;EACA,YAAA;EACA,eAAA;EACA,4CAAA;AAAF;;AAGA;EACE,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,kBAAA;EACA,gCAAA;EACA,+BAAA;EACA,yCAAA;EACA,kBAAA;EACA,+BAAA;AAAF;;AAGA;;EAEE,mBAAA;AAAF","sourcesContent":[".progress {\n  --progress-background: var(--addition-50_40);\n  --progress-pin-size: 16px;\n\n  position: relative;\n  height: 6px;\n  cursor: pointer;\n}\n\n.progress:focus-visible {\n  box-shadow: 0 0 0 2px var(--info-30);\n}\n\n.progress-bar-wrapper {\n  position: relative;\n  height: 100%;\n  border-radius: 8px;\n  overflow: visible;\n}\n\n.progress-background {\n  width: 100%;\n  height: 100%;\n  background-color: var(--progress-background);\n}\n\n.progress-bar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  max-width: 100%;\n  background-color: var(--brand-primary-40);\n}\n\n.progress-bar-animated {\n  transition: width 300ms linear;\n  will-change: width;\n}\n\n.progress-buffer {\n  position: absolute;\n  top: 0;\n  height: 100%;\n  max-width: 100%;\n  background-color: var(--progress-background);\n}\n\n.progress-pin {\n  position: absolute;\n  top: 50%;\n  inset-inline-end: 0px;\n  visibility: hidden;\n  height: var(--progress-pin-size);\n  width: var(--progress-pin-size);\n  background-color: var(--brand-primary-40);\n  border-radius: 50%;\n  transform: translate(50%, -50%);\n}\n\n.progress:hover .progress-pin,\n.progress-pin-active {\n  visibility: visible;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progress": `MediaPlayerProgress__progress-c22a36`,
	"progress-bar-wrapper": `MediaPlayerProgress__progress-bar-wrapper-ef39e2`,
	"progressBarWrapper": `MediaPlayerProgress__progress-bar-wrapper-ef39e2`,
	"progress-background": `MediaPlayerProgress__progress-background-df572c`,
	"progressBackground": `MediaPlayerProgress__progress-background-df572c`,
	"progress-bar": `MediaPlayerProgress__progress-bar-d31794`,
	"progressBar": `MediaPlayerProgress__progress-bar-d31794`,
	"progress-bar-animated": `MediaPlayerProgress__progress-bar-animated-bb62c0`,
	"progressBarAnimated": `MediaPlayerProgress__progress-bar-animated-bb62c0`,
	"progress-buffer": `MediaPlayerProgress__progress-buffer-ad2712`,
	"progressBuffer": `MediaPlayerProgress__progress-buffer-ad2712`,
	"progress-pin": `MediaPlayerProgress__progress-pin-a76df6`,
	"progressPin": `MediaPlayerProgress__progress-pin-a76df6`,
	"progress-pin-active": `MediaPlayerProgress__progress-pin-active-fab301`,
	"progressPinActive": `MediaPlayerProgress__progress-pin-active-fab301`
};
module.exports = ___CSS_LOADER_EXPORT___;
